import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/my-transactions',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/my-transactions',
      name: 'my-transactions',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/MyTransactions.vue')
    }

  ]
};
export default app;
